export const API_BASE_URL = 'https://referral-api.symbioway.ru'
